import styled from 'styled-components'
import {DisabledButton} from './disabled-button.styled'

export const LargerDisabledButton = styled(DisabledButton)`
    width: 45px;
`
